import {useOrders} from 'api/queries';
import {useEffect, useState} from 'react';

import {useAuth} from './useAuth';

export const useActiveOrders = () => {
  const [limit, setLimit] = useState(5);
  const {isAuthenticated} = useAuth();

  const onHandlerSetLimit = () => {
    setLimit((prev) => prev + 5);
  };

  const {
    data: orders,
    refetch,
    isFetching,
  } = useOrders(
    {limit},
    {
      enabled: !!isAuthenticated,
    },
  );

  useEffect(() => {
    if (!isFetching && isAuthenticated) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  const ordersActive = orders?.filter(
    (item) => !item.is_canceled && !item.delivered, //this order in the process
  );

  return {
    ordersActive: ordersActive ?? [],
    orders: orders ?? [],
    onHandlerSetLimit,
    isLoadingOrders: isFetching,
    refetch,
  };
};
